import React from 'react';
import { Tabs, Tab } from "material-ui/Tabs";
import IconMenu from 'material-ui/IconMenu';
import Snackbar from 'material-ui/Snackbar';
import MenuItem from 'material-ui/MenuItem';
import IconButton from 'material-ui/IconButton/IconButton';
import { withRouter } from 'react-router-dom';
import Divider from 'material-ui/Divider';
import Badge from 'material-ui/Badge'

import { store } from '../../stores/configureStore';
import { push } from 'react-router-redux'

//services
import DataService from '../../services/DataService'; var ds = DataService;
import LocalStorageService from '../../services/LocalStorageService'; var ls = LocalStorageService;

const HeaderIconButtonStyle = {
  width: '60px',
  height: '60px'
};

const listItemStyle = {
  paddingLeft: '40px' // 36 + 16, algin with sub list
};

class NavLeftList extends React.Component {
  constructor() {
    super();
    this.state = {
      maxItems: 7,
      all_requests: [],
      alert_requests: [],
      requests_raw: [],
      alerts_raw: [],
      selectedID: "Services",
      unseen_count: 0,
      unseen_alert_count: 0,
      snack: {
        open: false,
        message: ''
      },
    }
    this.audio = new Audio('../../assets/audio/notification.mp3')
  }

  closeSnack() {
    this.setState({
      snack: {
        open: false,
        message: ''
      }
    })
  }

  handleChange = (event, value) => {
    this.props.history.push(value);
  }

  componentDidMount() {
    this.getUnseenCount(1,'all');
    window.addEventListener('_mqt', (e) => {
      if (e && e.detail && e.detail.act_type == "new_service") {
        this.getUnseenCount(1,e.detail);
      }
      // if (e && e.detail && e.detail.act_type == "intrusion_alert") {
      //   this.getUnseenCount(1,e.detail);
      // }
  })
  }

    componentWillUnmount() {
      this.setState({snack:{open:false,message:''}})
    window.removeEventListener('_mqt', (data) => { console.log(data) })
}

  getUnseenCount(first=0,name='') {
    if(name.act_type == "new_service" || name == "all") {
      ds.getUnseenNotifCount(data => {
        if(first == 1 ){
          let snack = {
            open: true,
            message: "New "+ name.name +" Request!"
          };
          if(name != 'all'){
            this.setState({snack:{ open: true,
              message: "New "+ name.name +" Request!"}})
            this.audio.play();
          }
          }
        this.setState({
          unseen_count: parseInt(data)
        })
      }, err => {});
    }
    // if(name.act_type == "intrusion_alert" || name == "all") {
    //   ds.getIntrusionsCount({},data => {
    //     if(first == 1){
    //       // let snack = {
    //       //   open: true,
    //       //   message: "New Intrusion Alert!"
    //       // };
    //       if(name != 'all'){
    //         this.setState({snack:{open: true,
    //           message: "New Intrusion Alert!"}})
    //         console.log("swewew");
    //         this.audio.play();
    //       }
    //     }
    //     this.setState({
    //       unseen_alert_count: parseInt(data.unseen_notifications_count)
    //     })
    //   }, err => {});
    // }
  }

  clearUnseenCount() {
    let c = [];
    for (let i of this.state.requests_raw) {
      if (!i.seen) {
        c.push(i._id);
      }
    }

    if (c.length) {
      ds.postChangeUnseenCount({
        requests: c
      }, data => {
        if(this.state.unseen_count >= c.length){
        this.setState({
          unseen_count: this.state.unseen_count - c.length
        });
      }
      }, 
      () => {})
    }
  }

  clearUnseenAlertCount() {
    let c = [];
    for (let i of this.state.alerts_raw) {
      if (!i.seen) {
        c.push(i._id);
      }
    }

    if (c.length) {
      // ds.postChangeUnseenAlertCount({
      //   alert_ids: c
      // }, data => {
      //   if(this.state.unseen_alert_count >= c.length){
      //     this.setState({
      //       unseen_alert_count: this.state.unseen_alert_count - c.length
      //     });
      //   }
      // }, 
      // () => {})
    }
  }

  getAllRequests() {
    // ds.getIntrusions({hotel_id:ls.getUserDetails().hotel_id,limit: 7,offset: 0},
    // data => {
    //   let obj = {};
    //   if(data.unseen_notifications && data.unseen_notifications.length) {
    //     let raw = data.unseen_notifications.slice();
    //     for(let row of data.unseen_notifications) {
    //       if(row.timestamp) {
    //         let cell = row.timestamp * 1000;
    //         let x = new Date(cell);
    //         row.time = x && x != 'Invalid Date' ? x.toLocaleTimeString() : 'Unknown'
    //         row.date = x && x != 'Invalid Date' ? x.toDateString() : 'Unknown'; 

    //         let start = new Date(row.timestamp * 1000)
    //         start.setHours(0,0,0,0);
    //         if (!obj[start.toISOString()]) {
    //           let b = start.toISOString();
    //           obj[b] = [];
    //         }
    //         obj[start.toISOString()].push(row);
    //       }
    //     }
    //     let y = [];
    //     for (let i of Object.keys(obj)) {
    //       y.push({
    //         items: obj[i],
    //         date: new Date(i)
    //       });
    //     }
    //     this.setState({
    //       alert_requests: y,
    //       alerts_raw: raw,
    //       snack: {
    //         open: false,
    //         message: ''
    //       }

    //     }, () => {
    //       //this.clearUnseenAlertCount();
    //     });
    //   }
    // },()=>{

    // })
    ds.getServiceRequests(ls.getUserDetails().hotel_id, this.state.maxItems, 0,
      data => {
        let obj = {};
        if (data.service && data.service.length) {
          let raw = data.service.slice();
          for (let row of data.service) {
            if (row.timestamp) {
              let cell = row.timestamp;
              let x = new Date(cell);
              row.time = x && x != 'Invalid Date' ? x.toLocaleTimeString() : 'Unknown'
              row.date = x && x != 'Invalid Date' ? x.toDateString() : 'Unknown';

              let start = new Date(row.timestamp)
              start.setHours(0, 0, 0, 0);

              if (!obj[start.toISOString()]) {
                let b = start.toISOString();
                obj[b] = [];
              }
              obj[start.toISOString()].push(row);
            }
          }

          let y = [];
          for (let i of Object.keys(obj)) {
            y.push({
              items: obj[i],
              date: new Date(i)
            });
          }

          this.setState({
            all_requests: y,
            requests_raw: raw,
            snack: {
              open: false,
              message: ''
            }

          }, () => {
            this.clearUnseenCount();
          });
        }
      }, 
      () => {}
    );
  }

  goToReqestsList(item) {
    let service = item == 'Food Order'? 'Food' : item;
    store.dispatch(push('/app/services/requests/'+service));
  }

  goToAlertsList(item) {
    let service = item;
   // store.dispatch(push('/app/services/alerts'));
  }

  render() {
    return (
      <div>
          <Snackbar
           style={{ height: "100%"}}
           bodyStyle={{backgroundColor: "#3abcd4", marginTop: '10px'}}
            anchorOrigin={{
              vertical: 'top', horizontal: 'center' 
            }}
            open={this.state.snack.open}
            autoHideDuration={10000}
            onClose={this.closeSnack.bind(this)}
            ContentProps={{
              'aria-describedby': 'message-id',
            }}
            message={<span style={{fontSize:'18px'}} id="message-id">{this.state.snack.message}</span>}
            action={[
              <IconButton
                key="close"
                aria-label="Close"
                color="#fff"
                onClick={this.closeSnack.bind(this)}
              >
                <i className="material-icons white-fg mt-5px">close</i>
              </IconButton>,
            ]}
          />
      <ul className="list-unstyled list-inline">
        <li className="list-inline-item">
          <Badge
            badgeContent={this.state.unseen_count }//+ this.state.unseen_alert_count}
            secondary={true}
            badgeStyle={{ top: 5, right: 20, opacity: (this.state.unseen_count)? 1 : 0}}//||this.state.unseen_alert_count) ? 1 : 0 }}
            style={{ paddingTop: 0 }}
          >
            <IconMenu
              iconButtonElement={
                <IconButton
                  style={HeaderIconButtonStyle}
                  className="md-button header-btn"
                >
                <i className="material-icons">notifications_none</i>
                </IconButton>
              }
              onClick={this.getAllRequests.bind(this)}
              onChange={this.handleChange}
              anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
              targetOrigin={{ horizontal: 'left', vertical: 'top' }}
              menuStyle={{ minWidth: '280px' }}
            >
              <Tabs
              value={this.state.selectedID}
              className="tabs-container tabs1-container"
              scrollable
              scrollButtons="auto"
              onChange={(e) => {
                if(e == "Services"){

                }
                if(e == "Alerts"){
                  this.clearUnseenAlertCount();
                }
    this.setState({ selectedID: e });
              }}
              style={{ width: "100%" }}
            >
                  <Tab
                    label={"Services"}
                    className="tab"
                    value={"Services"}
                  >
                    <div
                      key={"Services"}
                      className="col-sm-11 col-11 mb-1vw h-100 p-0 customShadow"
                      zDepth={3}
                      style={{
                        maxWidth: '100%',
                        display:
                          this.state.selectedID == "Services"
                            ? "block"
                            : "none",
                      }}
                    >
                       {
                this.state.all_requests && this.state.all_requests.length ?
                  this.state.all_requests.map(
                    (obj, ind) => {
                      return (
                        <div>
                          <span className="text-muted p-1vw">{obj.date.toDateString ? obj.date.toDateString() : ''}</span>
                          {
                            obj.items.map(
                              item => {
                                return (
                                  <MenuItem
                                    className="header-icon-dropdown-item"
                                    key={item._id}
                                    primaryText={
                                      <div 
                                        className={
                                          item.seen ? '' : 'green-fg'
                                        }
                                      >
                                        {
                                          item.service && item.hotel_room_id ? 
                                            `${item.service.name} request from ${item.hotel_room_id.name}` 
                                          : ''
                                        }
                                      </div>
                                    }
                                    secondaryText=""
                                    onClick={this.goToReqestsList.bind(this,item.service.name)}
                                  />
                                )
                              }
                            )
                          }

                          {
                            ind != this.state.all_requests.length - 1 ? 
                              <div className="mb-1vw">
                                <Divider />
                              </div> 
                            : null
                          }
                        </div>
                      )
                    }
                  ) 
                :
                <MenuItem
                  className="header-icon-dropdown-item"
                  primaryText={
                    <span className="text-muted">No new notifications</span>
                  }
                  secondaryText=''
                />
              }
                    </div>
                  </Tab>
                  {/* <Tab
                    label={"Alerts"}
                    className="tab"
                    value={"Alerts"}
                  >
                    <div
                      key={"Alerts"}
                      className="col-sm-11 col-11 mb-1vw h-100 p-0 customShadow"
                      zDepth={3}
                      style={{
                        maxWidth: '100%',
                        display:
                          this.state.selectedID == "Alerts"
                            ? "block"
                            : "none",
                      }}
                    >
                       {
                this.state.alert_requests && this.state.alert_requests.length ?
                  this.state.alert_requests.map(
                    (obj, ind) => {
                      return (
                        <div>
                          <span className="text-muted p-1vw">{obj.date.toDateString ? obj.date.toDateString() : ''}</span>
                          {
                            obj.items.map(
                              item => {
                                return (
                                  <MenuItem
                                    className="header-icon-dropdown-item"
                                    key={item._id}
                                    primaryText={
                                      <div 
                                        className={
                                          item.seen ? '' : 'green-fg'
                                        }
                                      >
                                        {
                                          item.device_name && item.hotel_room_id ? 
                                            `${item.device_name} in ${item.hotel_room_name} triggered` 
                                          : ''
                                        }
                                      </div>
                                    }
                                    secondaryText=""
                                    onClick={this.goToAlertsList.bind(this,item.device_name)}
                                  />
                                )
                              }
                            )
                          }

                          {
                            ind != this.state.all_requests.length - 1 ? 
                              <div className="mb-1vw">
                                <Divider />
                              </div> 
                            : null
                          }
                        </div>
                      )
                    }
                  ) 
                :
                <MenuItem
                  className="header-icon-dropdown-item"
                  primaryText={
                    <span className="text-muted">No new notifications</span>
                  }
                  secondaryText=''
                />
              }
                    </div>
                  </Tab> */}
            </Tabs>

              <Divider />

              <MenuItem
                className="header-icon-dropdown-item"
                leftIcon=''
                secondaryText={<span className="text-muted">See All ...</span>}
                onClick={()=>{
                  console.log("asdasdasd");
                  if(this.state.selectedID === 'Services')
                {
                  this.goToReqestsList('all')
                } else {
                  //this.goToAlertsList()
                }}}
              />
            </IconMenu>
          </Badge>
        </li>
      </ul>
      </div>
    );
  }
}

module.exports = withRouter(NavLeftList);



// WEBPACK FOOTER //
// ./components/Header/NavLeftList.js